<template>
  <div>
    <div style="margin-top: 10px">
      <el-button type="info" size="mini" round> 全部</el-button>
      <el-button style="float: right"
                 type="success"
                 size="small "
                 title="我要评价"
                 round
                 @click="toComment"
                 v-if="this.$store.state.userInfo">
        我要评价
      </el-button>
      <el-button style="float: right"
                 type="primary"
                 size="small "
                 title="评价请登录"
                 round
                 @click="toLogin"
                 v-else>
        评价请登录
      </el-button>
    </div>
    <!--评价内容-->
    <div style="margin-top: 20px">
      <div v-if="commentArray.length === 0" style="margin:40px 0;text-align: center">
        <img src="@/assets/img/none.png" alt="" width="240" height="240">
      </div>
      <!--用户评价-->
      <el-card class="box-card" v-for="(comment,index) in commentArray" :key="comment.commentId">
        <div class="comment">
          <div style="width: 70px; float: left">
            <el-avatar :size="50" @error="errorHandler">
              <img :src="comment.headImg" alt=""/>
            </el-avatar>
          </div>
          <div class="comment-content">
            <div class="title">{{comment.username}}</div>
            <div class="content">
              {{comment.content}}
            </div>
            <div>
              <div style="margin-top: 14px">
                <span class="comment-date">{{comment.createdTime}}</span>
              </div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <!--分页-->
    <div style="margin-top: 40px;text-align: center">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="this.pageInfo.pageSize"
        :current-page="this.pageInfo.pageNum"
        @current-change="handleCurrentChange"
        :total="this.pageInfo.total"
        v-if="commentArray.length > 0">
      </el-pagination>
    </div>
    <!--评价对话框-->
    <el-dialog
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose"
      :lock-scroll = false
      custom-class="comment-dialog">
      <div style="margin-top: -25px">
        <div style="margin-bottom: 22px">
          <span style=" font-size: 16px;font-weight: bold;color: #1c1f21;"> 我要评价</span>
        </div>
        <el-input
          type="textarea"
          placeholder="扯淡、吐槽、表扬、鼓励……想说啥就说啥！"
          v-model="commentContent"
          maxlength="300"
          show-word-limit
          rows="4"
        >
        </el-input>
        <div style="margin-top: 25px">
          <el-row style="text-align: right">
            <el-col :span="10">
             <div style="height: 1px"></div>
            </el-col>
            <el-col :span="9">
              <el-alert
                :title="alertTitle"
                type="warning"
                show-icon
                center
                :closable="false"
                style="background-color: #FFFFFF;color: #be3948;"
                :style="{visibility: isHidden? 'hidden':'visible'}">
              </el-alert>
            </el-col>
            <el-col :span="5">
              <el-button type="primary" @click="commit" round>发表评论</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "Comment",
    props: {
      commentArray: Array,
      courseId: String,
      pageInfo: Object,
      isHaveCourse: Boolean
    },
    data() {
      return {
        dialogVisible: false,
        commentContent: '',
        alertTitle: '', // 警告信息
        isHidden: true, // 是否隐藏
        isBuyCourse: ''
      }
    },
    methods: {
      //判断是否购买课程
      async isBuy(){
        const { content } = await this.$http.get('/business/web/userCourse/isBuyCourse', {params:{courseId:this.$route.params.courseId}});
        this.isBuyCourse = content;
      },
      errorHandler() {
        return true;
      },
      handleCurrentChange(pageNum) {
         this.pageInfo.pageNum = pageNum;
         this.getPageListComment();
      },
      getPageListComment() {
        this.$emit("getPageListComment", {
          "pageNum":this.pageInfo.pageNum,
          "pageSize":this.pageInfo.pageSize
        });
      },
      handleClose() {
        this.dialogVisible = false;
        this.isHidden = true; // 隐藏警告
        this.commentContent = '';
      },
      async toComment() {
        if (this.isHaveCourse){
          this.dialogVisible = true;
        }else {
          this.$alert('非本学习班课程哦^ - ^', '提示', {
            confirmButtonText: '确定',
            type: "warning"
          });
        }
      },
      async commit() {
        if (this.commentContent.length < 5) {
          this.alertTitle = '内容不能少于5个字符！';
          this.isHidden = false;
          return;
        }
        const {success} = await this.$http.post('/business/web/comment/create',
          {'courseId':this.courseId,'content':this.commentContent});

        this.isHidden = true;
        this.dialogVisible = false;
        if (success) {
          this.$message.success("评价成功,候等管理员审批！");
        }
      },
      toLogin() {
        this.$router.push({ path: '/login' });
      }
    },
    created() {
      // this.isBuy();
    }
  }
</script>

<style lang="scss" scoped>
  .com-bar {
    margin-bottom: 30px;
  }

  /deep/ .el-card__body {
    padding: 0;
  }

  .box-card {
    border-radius: 12px;
    margin-bottom: 10px;
    box-shadow: 0 4px 8px 0 rgba(7,17,27,.1);
  }
  .comment {
    padding: 25px 30px;
    background-color:#FFFFFF;
  }
  .comment-content {
    padding-right: 20px;
    min-height: 80px;
    position: relative;
    overflow: hidden;
    word-wrap: break-word;
    word-break: break-all;
  }
  .title {
    font-size: 15px;
    color: #1c1f21;
    font-weight: 700;
  }
  .content {
    margin-top: 8px;
    font-size: 14px;
  }
  .comment-date {
    color: #93999f;
    font-size: 14px;
    float: right;
  }

</style>
